/* unplugin-vue-components disabled */import { render } from "./BlankAsTextSettingsDialog.vue?vue&type=template&id=2095340e&scoped=true&ts=true"
import script from "./BlankAsTextSettingsDialog.vue?vue&type=script&lang=ts"
export * from "./BlankAsTextSettingsDialog.vue?vue&type=script&lang=ts"

import "./BlankAsTextSettingsDialog.vue?vue&type=style&index=0&id=2095340e&lang=scss&scoped=true"
import "./BlankAsTextSettingsDialog.vue?vue&type=style&index=1&id=2095340e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2095340e"]])

export default __exports__